<template>
	<modal ref="modal">
		<template #title>Add Beneficiary</template>
		<template #body>
			<form @submit.prevent="addBeneficiary" autocomplete="off">
				<div class="form-floating mb-4">
					<input
						id="fname"
						v-model="form.fname"
						:class="{ 'is-invalid': form.errors.fname }"
						type="text"
						class="form-control"
						placeholder="Enter your fname"
						autofocus
					/>
					<label class="form-label" for="fname">First Name</label>
					<div v-if="form.errors.fname" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.fname }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<input
						id="lname"
						v-model="form.lname"
						:class="{ 'is-invalid': form.errors.lname }"
						type="text"
						class="form-control"
						placeholder="Enter your lname"
					/>
					<label class="form-label" for="lname">Last Name</label>
					<div v-if="form.errors.lname" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.lname }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<flat-pickr
						id="birthday"
						v-model="form.birthday"
						v-bind:class="
							form.errors.birthday
								? 'flatpickr-input is-invalid border-danger'
								: 'flatpickr-input'
						"
						class="form-control"
						placeholder="Enter your birthday"
					/>
					<label class="form-label" for="birthday">Birthday</label>
					<div v-if="form.errors.birthday" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.birthday }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<input
						id="relationship"
						v-model="form.relationship"
						:class="{ 'is-invalid': form.errors.relationship }"
						type="text"
						class="form-control"
						placeholder="Enter your relationship"
						autofocus
					/>
					<label class="form-label" for="relationship">Relationship</label>
					<div v-if="form.errors.relationship" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.relationship }}
					</div>
				</div>
				<button
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold mb-3"
				>
					Submit
				</button>
			</form>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			fname: null,
			lname: null,
			birthday: null,
			relationship: null,
		})

		const addBeneficiary = () => {
			form.post(route('post.add-beneficiary'), {
				preserveState: true,
				preserveScroll: true,
				only: ['errors', 'beneficiaries'],
				onSuccess: () => {
					form.reset()
					toggleModal()
				},
			})
		}

		return {
			modal,
			toggleModal,
			form,
			addBeneficiary,
		}
	},
}
</script>
